import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { toast } from 'sonner';

export const CREATE_USER_MUTATION = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      user {
        id
        email
        fullName
        role
        disabled
        forcePasswordChange
        createdAt
        updatedAt
      }
    }
  }
`;

interface CreateUserResponse {
  createUser: {
    user: {
      id: string;
      email: string;
      fullName: string;
      role: string;
      disabled: boolean;
      forcePasswordChange: boolean;
      createdAt: string;
      updatedAt: string;
    };
  };
}

export function useCreateUser(options?: { onCompleted?: () => void; onError?: (error: any) => void }) {
  const [createUserMutation, { loading }] = useMutation<CreateUserResponse>(CREATE_USER_MUTATION, {
    onCompleted: options?.onCompleted,
    onError: (error: any) => {
      if (options?.onError) {
        options.onError(error);
      } else {
        const message = error.graphQLErrors?.[0]?.message || error.message || 'Falha ao criar usuário';
        toast.error(message);
      }
    },
  });

  const createUser = (email: string, fullName: string, role?: string) => {
    return createUserMutation({
      variables: { input: { email, fullName, role } },
    });
  };

  return { createUser, loading };
}
